<template>
  <button class="btn-points">
    <DotsIcon />
  </button>
</template>

<script setup>
  import DotsIcon from '@shared/UI/Svg/ui/Dots.vue';
</script>

<style scoped lang="scss">
  @import "./styles";
</style>